/* Make the Best Seller Section Clickable */
var bestSeller = document.querySelector("section:has(ul.grid.product-grid.contains-card.contains-card--standard.grid--2-col-desktop.grid--2-col-tablet-down) slider-component");
var bestSellerLink = "";
if (window.location.href.includes("zh-hant")) {
  bestSellerLink = "zh-hant/products/gutolution™-adults-precision-probiotics-program";
} else if (window.location.href.includes("zh-hans")) {
  bestSellerLink = "zh-hans/products/gutolution™-adults-precision-probiotics-program";
} else {
  bestSellerLink = "products/gutolution™-adults-precision-probiotics-program";
}
var newBestSeller = document.createElement('a');
newBestSeller.href = bestSellerLink;
newBestSeller.innerHTML = bestSeller.outerHTML;
bestSeller.parentNode.replaceChild(newBestSeller, bestSeller);